function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#303c42",
  d: "M24 6c0-3.309-2.691-6-6-6-1.771 0-3.36.776-4.46 2H2C.897 2 0 2.897 0 4v18c0 1.103.897 2 2 2h18c1.103 0 2-.897 2-2V11.497c.965-1.528 1.785-3.041 1.958-4.807.026-.227.042-.456.042-.69z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#66bb6a",
  d: "M2 3h10.812A5.958 5.958 0 0 0 12 6c0 .234.016.463.042.682a7.68 7.68 0 0 0 .375 1.695L1 19.793V4c0-.551.449-1 1-1z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fdd835",
  d: "M1 22v-.793L12.822 9.385c.361.78.808 1.534 1.292 2.294L2.793 23H2c-.551 0-1-.449-1-1z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1.5 21.5v-.793l-.5.5V22c0 .551.449 1 1 1h.793l.5-.5H2.5c-.551 0-1-.449-1-1z",
  opacity: 0.2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M14.668 12.539c.494.761.989 1.537 1.436 2.359L14.207 13l.461-.461z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#42a5f5",
  d: "M11 16.207 17.793 23H4.207z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#f2f2f2",
  d: "M20 23h-.793l-7.5-7.5 1.793-1.793 3.689 3.689c.124.388.236.785.321 1.204a.494.494 0 0 0 .952.069L21 21.207V22c0 .551-.449 1-1 1z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M18.76 17.553c.515-1.699 1.363-3.134 2.24-4.501v6.741l-2.24-2.24z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#ef5350",
  d: "M22.963 6.584c-.185 1.89-1.261 3.547-2.4 5.301-.906 1.396-1.906 2.935-2.563 4.77-.658-1.835-1.657-3.374-2.563-4.77-1.139-1.754-2.215-3.411-2.401-5.309A4.99 4.99 0 0 1 13 6c0-2.757 2.243-5 5-5s5 2.243 5 5c0 .195-.014.386-.037.584z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.5 10.5c1.654 0 3-1.346 3-3A.5.5 0 0 0 8 7H6a.5.5 0 0 0 0 1h1.437A2.004 2.004 0 0 1 5.5 9.5c-1.103 0-2-.897-2-2a2.002 2.002 0 0 1 3.202-1.599.5.5 0 1 0 .6-.8A2.977 2.977 0 0 0 5.5 4.5c-1.654 0-3 1.346-3 3s1.346 3 3 3z"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 6,
  r: 3,
  fill: "#303c42"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 6,
  r: 2,
  fill: "#e53935"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1.5 4.5c0-.551.449-1 1-1h10.062c.079-.169.156-.339.25-.5H2c-.551 0-1 .449-1 1v15.793l.5-.5V4.5z",
  opacity: 0.2
});

var _ref15 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 18.718,
  x2: 23.252,
  y1: 15.333,
  y2: 19.866,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
}));

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "m18.76 17.553 2.24 2.24v-6.741c-.877 1.367-1.725 2.801-2.24 4.501zM18 19a.487.487 0 0 1-.252-.076l-.001.002 3.222 3.222c.009-.05.031-.096.031-.148v-.793l-2.538-2.538A.494.494 0 0 1 18 19z"
});

var _ref17 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: -1.369,
  x2: 23.936,
  y1: 6.492,
  y2: 18.292,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M24 6c0-3.309-2.691-6-6-6-1.771 0-3.36.776-4.46 2H2C.897 2 0 2.897 0 4v18c0 1.103.897 2 2 2h18c1.103 0 2-.897 2-2V11.497c.965-1.528 1.785-3.041 1.958-4.807.026-.227.042-.456.042-.69z"
});

var SvgGoogleMaps = function SvgGoogleMaps(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "google-maps",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleMaps, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-maps.ac68ca61.svg";
export { ForwardRef as ReactComponent };